
import { VApp } from "vuetify/lib";

export default VApp.extend({});
